import { render, staticRenderFns } from "./LocationApptType.vue?vue&type=template&id=4891506c&scoped=true"
import script from "./LocationApptType.vue?vue&type=script&lang=js"
export * from "./LocationApptType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891506c",
  null
  
)

export default component.exports